
export const AgreementValidation = (formData) => {
    const errors = {};
    if (formData.formData.ClientType.toString() === "0") {
        if (!formData.formData.CustomerID || formData.formData.CustomerID === "0") {
            errors.CustomerID = 'This field is required';
        }

        if (!formData.formData.FK_ClientBranch_ID || formData.formData.FK_ClientBranch_ID === "0") {
            errors.FK_ClientBranch_ID = 'This field is required';
        }
        if (!formData.formData.FK_ClientContact_ID || formData.formData.FK_ClientContact_ID === "0") {
            errors.FK_ClientContact_ID = 'This field is required';
        }
    }
    if (!formData.formData.contractStartDate.trim()) {
        errors.contractStartDate = 'This field is required';
    }
    if (!formData.formData.contractEndDate.trim()) {
        errors.contractEndDate = 'This field is required';
    }
    if (!formData.formData.contractNumber || !formData.formData.contractNumber.trim()) {
        errors.contractNumber = 'This field is required';
    }
    if (!formData.formData.billing_Frequency || formData.formData.billing_Frequency === "0") {
        errors.billing_Frequency = 'This field is required';
    }
    if (formData.formData.contractEndDate && formData.formData.contractStartDate) {
        if (new Date(formatDate(formData.formData.contractEndDate)) < new Date(formatDate(formData.formData.contractStartDate))) {
            errors.contractEndDate = 'End Date must be greater than or equal to Start Date';
        }
    }



    return errors;
};
const formatDate = (dateStr) => {
    // Convert YYYY/MM/DD to YYYY-MM-DD
    return dateStr ? dateStr.replace(/\//g, '-') : '';
};